import { Button, Container, Grid } from '@mui/material'
import useSettings from '~/hooks/useSettings'
import Layout from '~/layouts'
import Page from '~/components/Page'
import { AppWelcome } from '~/sections/@dashboard/general/app'
import useAuth from 'hooks/useAuth'
import useLocales from 'hooks/useLocales'
import useProductPopup from 'hooks/useProductPopup'
import Carousel from '~/commons/components/Carousel'
import { ASSET_BASE_URL } from '~/config'
import IncomeOverview from 'domains/Dashboard/components/IncomeOverview'
import { useBoundIncomeOverviewStore } from 'domains/Dashboard/store'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import trackEvent from '~/trackers'
import StateImage from 'components/state-image'

GeneralApp.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>
}

const IS_HIDDEN_CREATE_CONTENT = false

export default function GeneralApp() {
  const { isReady, pathname, query } = useRouter()
  const { t } = useLocales()
  const { themeStretch } = useSettings()
  const { user, isAuthenticated } = useAuth()
  const { openProductModal } = useProductPopup()
  const trackerData = { pathname, query, user }

  const { isLoadingIncome, incomeOverview, getIncomeOverview } =
    useBoundIncomeOverviewStore((state) => ({
      isLoadingIncome: state.isLoadingIncome,
      incomeOverview: state.incomeOverview,
      getIncomeOverview: state.getIncomeOverview,
    }))

  useEffect(() => {
    if (isReady && isAuthenticated) {
      trackEvent.content('visit_creator_dashboard_hub', trackerData)
      getIncomeOverview()
    }
  }, [isReady, isAuthenticated])

  const bannerList = [
    {
      image: `${ASSET_BASE_URL}/content-hub/banner/socmed-ads-cuka-banner.webp`,
      link:
        process.env.NEXT_PUBLIC_BLOG_URL +
        `/mau-dapet-rp50ribu-ditambah-iphone-14-pro-max`,
      alt: 'banner-cuan-kreator',
    },
  ]

  return (
    <Page title="Creator Center: Dashboard">
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={3}>
          {/* TODO: when another feature is ready, change md={8} */}
          <Grid item xs={12} md={8}>
            <AppWelcome
              title={t('key_welcome_creator', {
                name: user?.displayName,
              })}
              description={t('key_welcome_creator_desc')}
              img={
                <StateImage
                  illustrationName="illustration_seo"
                  type="illustration"
                  sx={{
                    p: 3,
                    width: 360,
                    margin: { xs: 'auto', md: 'inherit' },
                    height: '100%',
                  }}
                />
              }
              action={
                !IS_HIDDEN_CREATE_CONTENT && (
                  <Button
                    variant="contained"
                    onClick={() => openProductModal(true)}
                  >
                    {t('key_create_product')}
                  </Button>
                )
              }
              sx={{
                padding: {
                  lg: '24px 0px',
                  xl: '0px',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Carousel
              data={bannerList}
              sx={{
                borderRadius: '8px',
                height: '120px',
                cursor: 'pointer',
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <IncomeOverview
              isLoading={isLoadingIncome}
              totalIncome={incomeOverview.total_income}
              totalTransaction={incomeOverview.total_transaction}
              month={incomeOverview.month}
              year={incomeOverview.year}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}
